export const facebooklink = "https://www.facebook.com/mariaadvisory/";

export const instagramlink = " https://www.instagram.com/mariaadvisory/";

export const linkedin = " https://www.linkedin.com/in/pooleymaria/";
